export const BASE_URL = "https://api.mylobbyman.ir";
export const API = `${BASE_URL}/api/`;
export const MEDIA_SERVER_BASE_URL = "https://media.mylobbyman.ir/api/Media/";

export const ENDPOINTS = {
  COUNTRY_SELECT: "CountrySelect",
  SEND_CONFIRMATION_CODE: "Customer/SendConfirmationCode",
  CHECK_CONFIRMATION_CODE: "Customer/CheckConfirmationCode",
  SP: "sp",
};

export enum SP_NAMES {
  UpdateUser = "Customer.Users_Update",
  AddMissedItem = "Customer.Lost_Insert",
  answerSurvey = "Customer.Answer_Insert",
  GetUserInfo = "Customer.User_SelectWithID",
  AddQuickMessage = "Customer.Suggestion_Insert",
  GetBuildingDataWithGuid = "Customer.Building_Select",
  GetBuildingSurveyParts = "Customer.BuildingPart_SelectWithID",
  GetBuildingSurveyQuests = "Customer.BuildingPartQuestion_Select",
}

export const SP_BASE_BODY = <P>(spName: SP_NAMES, parameters: P) => {
  return {
    spName,
    parameters,
  };
};
